export const PAGE_TABS = [
  { key: "lessons", label: "Lessons" },
  { key: "groups", label: "Groups" },
];

// Every param that scopes the session list. A link carrying any of them means
// "show me these sessions", so it belongs on Groups: a report's student or
// class, the window it was computed for, a flagged quote, a pinned session or
// bundle. Safe as a whole-list test because the Lessons view reads NOTHING
// from the URL — its filters come from storage — so no param here can mean
// Lessons. Give the Lessons view URL-driven filters and that stops being true;
// the contract is pinned by "keeps the Lessons view ignoring session params in
// the URL" in SessionHistory.test.js.
// educator_id is deliberately absent: it names whose page this is, not which
// sessions to show.
const GROUPS_PARAMS = [
  "session_id",
  "alert",
  "assignment_id",
  "student_id",
  "classroom_id",
  "standard_code",
  "collaboration_level",
  "date_range",
  "start_date",
  "end_date",
  "quote",
  "quote_id",
  "highlight_student",
];

// Which Session Reports view a URL opens. Shared by the page, the side nav's
// active row and the page header so all three read the same answer. An
// explicit ?tab= always wins; otherwise a scoped link opens Groups and only a
// bare URL falls back to the Lessons default.
export const initialTab = (search) => {
  const params = new URLSearchParams(search || "");
  const tab = params.get("tab");
  if (PAGE_TABS.some((t) => t.key === tab)) return tab;
  return GROUPS_PARAMS.some((p) => params.has(p)) ? "groups" : "lessons";
};
